import {Injectable} from "@angular/core";
import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {Order} from "../../../store/state/order.state";
import {AppState} from "../../../store/state/app.state";
import {Store} from "@ngrx/store";
import {OrderActions} from "../../../store/actions/order.actions";
import {distinctUntilChanged, filter, takeWhile} from "rxjs/operators";
import {BaseOrderFormService} from "../common/base-order-form.service";
import {TranslateService} from "@ngx-translate/core";
import {UmbrellaValidators} from "../../../umbrella-common/validation/umbrella-validators";
import {StandaloneFormService} from "../../../umbrella-common/services/standalone-form.service";

@Injectable()
export class CompanyHasCertificateFormService extends StandaloneFormService implements BaseOrderFormService {

	private disableHasCertStoreDispatch: boolean;
	private controlNamesInOrder: string[];

	constructor(private formBuilder: FormBuilder, private store: Store<AppState>, translate: TranslateService) {
		super(translate);
	}

	protected buildFormFor(formKey: string, [order]: [Order]) {
		this.controlNamesInOrder = ['multisite'].concat(order.products.map(product => 'hasCertificate_' + product.standard.name))
		const form = this.formBuilder.group({
			multisite: this.formBuilder.control(order.company.isMultiSite, UmbrellaValidators.radiobuttonRequired())
		});
		form.controls.multisite.valueChanges.pipe(takeWhile(() => this.isFormInitialized()), distinctUntilChanged())
			.subscribe(multiSite => multiSite != null && this.store.dispatch(OrderActions.SET_MULTISITE({multiSite})));

		order.products.forEach((product, i) => {
			const control = this.formBuilder.control(product.standard.hasCertificate, UmbrellaValidators.radiobuttonRequired());
			this.addControl(form, 'hasCertificate_' + product.standard.name, control);
			control.valueChanges.pipe(takeWhile(() => this.isFormInitialized()), filter(() => !this.disableHasCertStoreDispatch), distinctUntilChanged())
				.subscribe(hasCertificate => hasCertificate != null && this.store.dispatch(OrderActions.SET_HAS_ISO_CERTIFICATE({
					standardName: product.standard.name,
					hasCertificate
				})));
		});

		this.onSubmitClicked$().pipe(takeWhile(() => this.isFormInitialized())).subscribe(() => this.triggerValidations());
		return form;
	}

	getControlNamesInOrder(): string[] {
		return this.controlNamesInOrder;
	}

	override destroy() {
		super.destroy();
		this.disableHasCertStoreDispatch = false;
	}

	private addControl(form: FormGroup, name: string, control: AbstractControl) {
		form.addControl(name, control);
		this.controlNamesInOrder.push(name);
	}

	clearHasCertificateData(standardName: string) {
		const formControl = this.getFormControl(StandaloneFormService.FORM_KEY, `hasCertificate_${standardName}`);
		formControl && formControl.reset(null);
	}

	disableStoreDispatchForHasCertificateControls() {
		this.disableHasCertStoreDispatch = true;
	}

	fillOrder(order: Order): Order {
		order.company.isMultiSite = false;
		order.products.forEach(product => {
			product.standard.hasCertificate = this.getValueFor('hasCertificate_' + product.standard.name, StandaloneFormService.FORM_KEY);
		});

		this.enableInputs();
		return order;
	}

}
